<template>
  <v-container :fluid="true" class="bg-light-beige ma-0 pa-0">
    <Authorization/>
  </v-container>
</template>

<script>
import Authorization from "@/modules/core/pages/Authorization.vue"
import { defineComponent } from "vue"

export default defineComponent({
  name: "Registration",
  components: { Authorization },
})
</script>

<style scoped>

</style>
